"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
  _react = _interopRequireDefault(require("react")),
  _InputLabel = _interopRequireDefault(require("../FormElements/InputLabel")),
  _excluded = ["field", "value", "validationMessage", "touched", "setTouched", "hideField", "updateForm", "styledComponents", "error", "unsetError", "setFocusClass", "cssClass"],
  _default = exports["default"] = function (a) {
    var b = a.field,
      c = a.value,
      d = a.validationMessage,
      e = a.touched,
      f = a.setTouched,
      g = a.hideField,
      h = a.updateForm,
      i = a.styledComponents,
      j = a.error,
      k = a.unsetError,
      l = a.setFocusClass,
      m = a.cssClass,
      n = (0, _objectWithoutProperties2["default"])(a, _excluded),
      o = b.id,
      p = b.formId,
      q = b.type,
      r = b.label,
      s = b.placeholder,
      t = b.isRequired,
      u = b.maxLength,
      v = b.description,
      w = b.descriptionPlacement,
      x = b.labelPlacement,
      y = b.width,
      z = b.customName,
      A = i || !1,
      B = A.Textarea,
      C = void 0 === B ? "textarea" : B,
      D = A.Label,
      E = void 0 === D ? "label" : D,
      F = A.Box,
      G = void 0 === F ? "div" : F,
      H = (n || {}).i18n;
    return _react["default"].createElement(G, {
      width: y,
      className: d && e || j ? "form-field error ".concat(m) : "form-field ".concat(m),
      style: {
        display: g ? "none" : void 0
      }
    }, _react["default"].createElement("div", {
      className: q
    }, _react["default"].createElement(_InputLabel["default"], {
      formId: p,
      id: o,
      label: r,
      labelPlacement: x,
      isRequired: t,
      styledComponent: i
    }), "above" === w && v && _react["default"].createElement("div", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: v
      }
    }), _react["default"].createElement(C, {
      id: "input_".concat(p, "_").concat(o),
      name: z || "input_".concat(o),
      type: q,
      value: c ? c : "",
      placeholder: s,
      maxLength: u,
      required: t,
      onChange: function onChange(a) {
        h(a, b), k(o);
      },
      onBlur: function onBlur(a) {
        h(a, b), f(o), l("" !== c);
      },
      onFocus: function onFocus() {
        return l(!0);
      },
      "aria-describedby": "error_".concat(p, "_").concat(o),
      "aria-invalid": !!d && e || !!j
    }), u && 0 < u && _react["default"].createElement("div", {
      className: "charleft"
    }, H ? "".concat(H.t("maxCharachters", {
      length: c.length || 0,
      maxLength: u
    })) : "".concat(c.length || 0, " of ").concat(u, " max charachters")), "above" !== w && v && _react["default"].createElement("div", {
      className: "description",
      dangerouslySetInnerHTML: {
        __html: v
      }
    }), (d && e || j) && _react["default"].createElement("span", {
      className: "error-message",
      id: "error_".concat(p, "_").concat(o)
    }, d || j)));
  };